import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight',
  pure: false
})
export class HighlightPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, search: string): SafeHtml {
    if (!value) return ''; // agar value null/undefined ho to empty string return

    const stringValue = value.toString();

    if (!search) {
      // jab search nahi ho to bhi SafeHtml return karo with original case
      return this.sanitizer.bypassSecurityTrustHtml(`<span style="text-transform: none !important;">${stringValue}</span>`);
    }

    const pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    const regex = new RegExp(pattern, 'gi');
    const newValue = stringValue.replace(regex, (match :any) => `<span class="highlight-text" style="text-transform: none !important;">${match}</span>`);

    // wrap entire text to preserve original case
    return this.sanitizer.bypassSecurityTrustHtml(`<span style="text-transform: none !important;">${newValue}</span>`);
  }
}
  